// eslint-disable-next-line
const useAndroidBackButton = (onBackButton: () => void) => {};

export default useAndroidBackButton;
